import { ReactNode } from 'react'

import { formatCurrency } from '../../helpers'
import { StatCard } from '../SectionCard'

export type RevenueCardProps = {
  label: string
  value: number | null
  icon: ReactNode
  color: string
  highlight?: boolean
  action?: ReactNode
}

/**
 * Card de receita: um `<StatCard>` que recebe o valor em número e formata como moeda.
 *
 * A casca do card e o ladrilho do ícone eram escritos aqui à mão, iguais aos das outras quatro
 * cópias do painel; ficou só o que é deste card — a formatação em BRL e o `...` enquanto a
 * requisição não voltou.
 */
export function RevenueCard({ label, value, icon, color, highlight, action }: RevenueCardProps) {
  return (
    <StatCard
      label={label}
      value={value == null ? '...' : formatCurrency(value)}
      icon={icon}
      color={color}
      highlight={highlight}
      action={action}
    />
  )
}
